/**
 * Runtime hostname-based URL resolver.
 *
 * Given the browser's current hostname the app derives the matching
 * API, Auth0, and Payments (Marqeta) load-balancer URLs using the
 * prefix convention defined in CUSTOM_DOMAINS.md:
 *
 *   Host: app.acmecorp.com   → API: https://api.app.acmecorp.com
 *                           Auth: auth.app.acmecorp.com
 *                           Payments: https://payments.app.acmecorp.com
 *
 * During local development (localhost / 127.0.0.1) the resolver falls
 * back to the build-time VUE_APP_* env vars so existing .env files
 * keep working without changes.
 */

const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "0.0.0.0"]);

function isLocalDev() {
  if (typeof window === "undefined") return true;
  return LOCAL_HOSTS.has(window.location.hostname);
}

/**
 * Pure function: derive service URLs from an arbitrary hostname.
 * Useful for unit tests or previewing what a given host would resolve to.
 */
function resolveFromHostname(hostname) {
  return {
    hostname,
    apiBaseUrl: `https://api.${hostname}`,
    authDomain: `auth.${hostname}`,
    paymentsBaseUrl: `https://payments.${hostname}`,
    frontendOrigin: `https://${hostname}`,
  };
}

function resolve() {
  if (isLocalDev()) {
    return {
      hostname: "localhost",
      apiBaseUrl: process.env.VUE_APP_WHISTLE_API,
      authDomain: null,
      paymentsBaseUrl: process.env.VUE_APP_MARQETA_URL,
      frontendOrigin: window?.location?.origin ?? "http://localhost:8080",
    };
  }

  return resolveFromHostname(window.location.hostname);
}

const hostConfig = resolve();

export default hostConfig;
export { resolveFromHostname, isLocalDev };
